import { use, useContext, useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import InputController from '../../../../Global/InputController'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import ShowFormDynamic from './ShowFormDynamic'
import Location from './Location/Location'
import { GET_ALL_GROUPS } from '../../../../../graphql/Catalog/Groups/groups'
import { GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT } from '../../../../../graphql/Catalog/Groups/groupsCategories'
import { objNameRoles } from '../../../../../const/constRoles'
import { AuthContext } from '../../../../../Auth/AuthContext'

const extensions_allowed_file = ['.pdf']
const extensions_allowed_image = ['.png', '.jpg', '.jpeg']
const sizeMaxFile = 8 // EXPRESADO EN MB.
const priorityOptions = [
  { value: 'normal', label: 'Normal' },
  { value: 'urgente', label: 'Urgente' },
  // { value: 'especial', label: 'Especial' },
]

const StepReport = ({
  refWizard,
  setIsValidSteps,
  data,
  setData,
  setIsFinish,
}) => {
  const { user } = useContext(AuthContext)
  const roleEnlace = objNameRoles.enlace_de_gobierno
  const isRoleEnlace = user?.role === roleEnlace
  const { showLoading, hideLoading } = useLoading()

  //STATES
  const [disabled, setDisabled] = useState(true)
  // const [location, setLocation] = useState(null)
  const [isFromSubmit, setIsFromSubmit] = useState(false)
  const [file, setFile] = useState(null)
  const [fileImg, setFileImg] = useState(null)
  const [formId, setFormId] = useState(null)
  const [groups, setGroups] = useState({
    selected: '',
    options: [],
    category: '',
    categoryObj: {},
    categories: [],
  })

  const [dataAddress, setDataAddress] = useState(null)

  //MUTATIONS
  const [getCategoriesFetch] = useMutation(
    GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT
  )

  //QUERY
  const {
    data: dataGroups,
    loading: loadingGroups,
    error: errorGroups,
  } = useQuery(GET_ALL_GROUPS, { fetchPolicy: 'no-cache' })

  //------ Yup schema -----
  const [validationSchemaRules, setValidationSchemaRules] = useState({
    group_id: Yup.string().required('Campo requerido'),
    group_category_sub_id: Yup.string().required('Campo requerido'),
    priority: Yup.string().required('Campo requerido'),
  })

  const [validationSchema, setValidationSchema] = useState(
    Yup.object().shape(validationSchemaRules)
  )

  //------ Yup form -----

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  })

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    getValues,
  } = methods

  useEffect(() => {
    if (isRoleEnlace) {
      const existsSpecialOption = priorityOptions.some(
        (option) => option.value === 'especial'
      )
      if (!existsSpecialOption) {
        priorityOptions.push({
          value: 'especial',
          label: 'Especial',
        })
      }
      setValue('priority', 'especial')
    }
  }, [isRoleEnlace])

  useEffect(() => {
    setValidationSchema(Yup.object().shape(validationSchemaRules))
  }, [validationSchemaRules])

  //FUNCTIONS
  const onSubmit = async (Data) => {
    try {
      if (!dataAddress?.markerPosition) {
        const address_places = document.getElementById('address_places')
        address_places.classList.add('is-invalid')

        return toastSweetAlert({
          mode: 'error',
          message: 'Debes de colocar la direccion en el mapa',
        })
      }

      if (!Data.group_id || Data.group_id === '')
        throw new Error('Falta el valor del grupo')
      else if (!Data.group_category_sub_id || Data.group_category_sub_id === '')
        throw new Error('Falta el valor de categoria')
      else if (!groups?.categoryObj?.group_category_id)
        throw new Error('No se encontro la categoria')

      const { priority, address_reference, group_id, group_category_sub_id } =
        Data

      const keysToRemove = [
        'address_reference',
        'evidences',
        'group_category_sub_id',
        'group_id',
        'priority',
      ]

      keysToRemove.forEach((key) => {
        delete Data[key]
      })

      setData({
        data_form_json: Data,
        file,
        fileImg,
        priority,
        group_id: parseInt(group_id),
        group_category_id: parseInt(groups.categoryObj.group_category_id),
        group_category_sub_id: parseInt(group_category_sub_id),
        address: { ...dataAddress, address_reference },
      })

      setIsValidSteps((old) => ({ ...old, step2: true }))

      setIsFromSubmit(true)
      setIsFinish(true)

      /* setGroups({
        selected: '',
        options: [],
        category: '',
        categoryObj: {},
        categories: [],
      }) */
      //refWizard.current?.nextTab()
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleClean = () => {
    reset()
    setData(null)
    setIsValidSteps((old) => ({ ...old, step2: false }))
    setFormId(null)
    setFile(null)
    setFileImg(null)
    setGroups((old) => ({
      ...old,
      selected: '',
      category: '',
      categoryObj: {},
      categories: [],
    }))
    setDataAddress(null)
    // setLocation(null)
    // setMarkerPosition(null)
  }

  const getCategories = async ({ group_id, lat, lng }) => {
    const { data: dataCategories } = await getCategoriesFetch({
      variables: { group_id: parseInt(group_id), lat, lng },
    })

    const arrayFormatCategories = []

    dataCategories.categories.map((item) => {
      const options = item.subs.map((sub) => ({
        value: sub.id,
        label: sub.name,
        category_group_name: item.name,
        ...sub,
      }))

      arrayFormatCategories.push({
        value: item.name,
        label: item.name,
        options,
      })
      return true
    })

    return { arrayCategories: dataCategories.categories, arrayFormatCategories }
  }

  const handleChangeGroups = async (selected) => {
    showLoading()
    try {
      if (!selected) {
        setValue('group_category_sub_id', '')
        setFormId(null)
        return setGroups((old) => ({
          ...old,
          selected: '',
          category: '',
          categoryObj: {},
          categories: [],
        }))
      }

      // const { arrayFormatCategories } = await getCategories({
      //   group_id: selected.value,
      // })

      setValue('group_category_sub_id', '')
      setFormId(null)
      setGroups((old) => ({
        ...old,
        selected: selected.value,
        categoryObj: {},
        // categories: arrayFormatCategories,
      }))
    } catch (error) {
    } finally {
      hideLoading()
    }
  }

  const handleChangeCategories = async (selected) => {
    try {
      resetDynamicForm()
      if (!selected) {
        setValue('group_category_sub_id', '')
        setFormId(null)
        return setGroups((old) => ({ ...old, category: '', categoryObj: {} }))
      }
      setFormId(selected?.form_id)
      setGroups((old) => ({
        ...old,
        category: selected.value,
        categoryObj: selected,
      }))
    } catch (error) {}
  }

  const handleFile = async (e, dragDrop) => {
    if (dragDrop) {
      if (!e) return
      const file = e[0]
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'
      ) {
        return handleFileImg(e, dragDrop)
      }

      const fileName = file.name.toLowerCase()
      const lastDot = fileName.lastIndexOf('.')
      const extension = fileName.slice(lastDot, fileName.length)

      if (extensions_allowed_file.indexOf(extension) === -1) {
        setFile(null)
        return toastSweetAlert({
          mode: 'error',
          message: 'Solo se admite PDF',
        })
      }
      if (file.size / 1048576 > sizeMaxFile) {
        setFile(null)
        return toastSweetAlert({
          mode: 'error',
          message: `El archivo no puede superar los ${sizeMaxFile}MB`,
        })
      }
      return setFile(file)
    }

    if (!e.target.files[0]) return

    if (
      e.target.files[0].type === 'image/jpeg' ||
      e.target.files[0].type === 'image/png' ||
      e.target.files[0].type === 'image/jpg'
    )
      return handleFileImg(e, dragDrop)

    const fileName = e.target.files[0].name.toLowerCase()
    const lastDot = fileName.lastIndexOf('.')
    const extension = fileName.slice(lastDot, fileName.length)

    if (extensions_allowed_file.indexOf(extension) === -1) {
      setFile(null)
      return toastSweetAlert({
        mode: 'error',
        message: 'Solo se admite PDF',
      })
    }

    if (e.target.files[0].size / 1048576 > sizeMaxFile) {
      setFile(null)
      return toastSweetAlert({
        mode: 'error',
        message: `El archivo no puede superar los ${sizeMaxFile}MB`,
      })
    }

    setFile(e.target.files[0])
  }

  const handleFileImg = async (e, dragDrop) => {
    if (dragDrop) {
      if (!e || e.length === 0) return
      const file = e[0]
      const fileName = file?.name?.toLowerCase()
      const lastDot = fileName?.lastIndexOf('.')
      const extension = fileName?.slice(lastDot, fileName.length)

      if (extensions_allowed_image.indexOf(extension) === -1) {
        setFileImg(null)
        return toastSweetAlert({
          mode: 'error',
          message: 'Solo se admite JPG, JPGE y PNG',
        })
      }
      if (file.size / 1048576 > sizeMaxFile) {
        setFileImg(null)
        return toastSweetAlert({
          mode: 'error',
          message: `El archivo no puede superar los ${sizeMaxFile}MB`,
        })
      }

      return setFileImg(file)
    }

    if (!e.target.files[0]) return

    const fileName = e.target.files[0].name.toLowerCase()
    const lastDot = fileName.lastIndexOf('.')
    const extension = fileName.slice(lastDot, fileName.length)

    if (extensions_allowed_image.indexOf(extension) === -1) {
      setFileImg(null)
      return toastSweetAlert({
        mode: 'error',
        message: 'Solo se admite JPG, JPGE y PNG',
      })
    }

    if (e.target.files[0].size / 1048576 > sizeMaxFile) {
      setFileImg(null)
      return toastSweetAlert({
        mode: 'error',
        message: `El archivo no puede superar los ${sizeMaxFile}MB`,
      })
    }

    setFileImg(e.target.files[0])
  }

  const handleRemoveFile = () => {
    setFile(null)
    setFileImg(null)
  }

  // const processSetData = async () => {
  //   try {
  //     if (!data) return

  //     const { arrayCategories, arrayFormatCategories } = await getCategories({
  //       group_id: parseInt(data.group_id),
  //     })

  //     let categorySeleted = {}

  //     const foundGroup = arrayCategories.find((group) => {
  //       return group.subs.find(
  //         (sub) => sub.id === parseInt(data.group_category_sub_id)
  //       )
  //     })

  //     if (foundGroup) {
  //       const category_group_name = arrayFormatCategories.find(
  //         (item) => item.label === foundGroup.name
  //       )
  //       if (category_group_name) {
  //         categorySeleted = category_group_name.options.find(
  //           (item) => item.value === parseInt(data.group_category_sub_id)
  //         )
  //       }
  //     }

  //     setIsFromSubmit(true)
  //     setGroups((old) => ({
  //       ...old,
  //       selected: `${data.group_id}`,
  //       category: categorySeleted?.value,
  //       categoryObj: categorySeleted,
  //       categories: arrayFormatCategories,
  //     }))
  //     setFormId(categorySeleted?.form_id)

  //     reset({
  //       ...data,
  //       group_category_sub_id: `${data.group_category_sub_id}`,
  //     })
  //     setValue('group_category_sub_id', `${data.group_category_sub_id}`)
  //   } catch (error) {}
  // }

  //EFFECTS
  useEffect(() => {
    if (!loadingGroups) {
      const list = dataGroups?.getAllGroups.map((item) => ({
        value: item.id,
        label: item.name,
      }))
      setGroups((old) => ({ ...old, options: list }))
    }
  }, [loadingGroups, dataGroups, errorGroups])

  // useEffect(() => {
  //   if (data && !isFromSubmit && groups?.options.length > 0) {
  //     processSetData()
  //   }
  // }, [data, isFromSubmit, groups])

  useEffect(() => {
    const fetchCategories = async () => {
      if (groups.selected) {
        const { arrayFormatCategories } = await getCategories({
          group_id: groups.selected,
          // lat: location.lat,
          // lng: location.lng,
        })

        clearCategorySelection()
        resetDynamicForm()

        if (arrayFormatCategories.length > 0) {
          setFormId(null)
          setFile(null)
          setFileImg(null)
          setGroups((old) => ({
            ...old,
            categories: arrayFormatCategories,
          }))
        } else {
          toastSweetAlert({
            mode: 'errorToast',
            message: 'No se encontraron categorias',
          })
          setFormId(null)
          setFile(null)
          setFileImg(null)
          setGroups((old) => ({
            ...old,
            categories: [],
          }))
        }
        setDisabled(false)
      } else {
        setDisabled(true)
      }
      return
    }

    fetchCategories()
  }, [groups.selected])

  const clearCategorySelection = () => {
    setValue('group_category_sub_id', '')
    setGroups((old) => ({
      ...old,
      category: '',
      categoryObj: {},
    }))
  }

  const resetDynamicForm = () => {
    setValidationSchemaRules({
      group_id: Yup.string().required('Campo requerido'),
      group_category_sub_id: Yup.string().required('Campo requerido'),
      priority: Yup.string().required('Campo requerido'),
    })
    setFormId(null)
    setFile(null)
    setFileImg(null)
  }

  const handleFilterOptions = (option, inputValue) => {
    const inputValueLower = inputValue.toLowerCase()
    const optionsGroupName = option.data.category_group_name
    const optionsGroupNameLower = optionsGroupName.toLowerCase()

    return (
      optionsGroupNameLower.includes(inputValueLower) ||
      option.label.toLowerCase().includes(inputValueLower)
    )
  }

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row mt-3">
            <div className="col-12">
              {/**Tenia clase ---> left-box-form */}
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <Title text="Tipo de reporte" />
                    <div className="mb-3 col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <InputController
                        label="Grupo"
                        type="text"
                        name="group_id"
                        inputType="choosen"
                        options={groups?.options}
                        control={control}
                        changeAction={(e) => handleChangeGroups(e)}
                        valueManual={groups.selected}
                        placeholder="Elige"
                        noOptionsMessage={() => 'Sin resultados'}
                        isClearable
                      />
                    </div>
                    <div className="mb-2 col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <InputController
                        disabled={disabled}
                        label="Categoría"
                        type="text"
                        name="group_category_sub_id"
                        inputType="choosen"
                        options={groups.categories}
                        control={control}
                        changeAction={(e) => handleChangeCategories(e)}
                        valueManual={groups.category}
                        placeholder="Elige"
                        noOptionsMessage={() => 'Sin resultados'}
                        isClearable
                        filterOption={(option, inputValue) =>
                          handleFilterOptions(option, inputValue)
                        }
                      />
                    </div>
                    <div className="mb-2 col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <InputController
                        name="priority"
                        label="Prioridad"
                        type="text"
                        inputType="choosen"
                        placeholderTxt="Elige"
                        options={priorityOptions}
                        control={control}
                        noOptionsMessage={() => 'Sin resultado'}
                        disabled={disabled || isRoleEnlace}
                      />
                    </div>
                  </div>
                </div>
                <Location
                  dataAddress={dataAddress}
                  setDataAddress={setDataAddress}
                  disabled={!groups.selected}
                  cols="col-12"
                  control={control}
                />
                <div className="col-12">
                  <div className="row mt-3">
                    {formId && groups?.category && groups?.categoryObj && (
                      <div className="col-12">
                        <Title
                          text="Formulario de categoría"
                          number={4}
                          // subtitle={
                          //   <div className="mb-1">
                          //     <div>{groups.categoryObj.label}</div>
                          //     <div style={{ fontSize: 9 }}>
                          //       {groups.categoryObj.category_group_name}
                          //     </div>
                          //   </div>
                          // }
                        />

                        <ShowFormDynamic
                          formId={formId}
                          control={control}
                          setValidationSchemaRules={setValidationSchemaRules}
                          onChangeFile={handleFile}
                          onChangeFileImg={handleFileImg}
                          handleRemoveFile={handleRemoveFile}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row control-btn-box">
            <button className="btn btn-migrates w-20" type="submit">
              {/* Crear reporte <i className="fas fa-save ml-1" /> */}
              Crear reporte
            </button>
            <span
              className="btn btn-migrates-white"
              onClick={() => handleClean()}
            >
              Limpiar
            </span>
          </div>
        </form>
      </FormProvider>
    </>
  )
}

export const Title = ({ text, number, subtitle }) => {
  return (
    <div className="title-box">
      <h3>
        {/* {number && (
          <span className="fa-stack" style={{ fontSize: '10px' }}>
            <i className="fas fa-circle fa-xs fa-stack-2x" />
            <span className="fa-stack-1x text-white" style={{ fontSize: 15 }}>
              {number}
            </span>
          </span>
        )} */}
        {text}
      </h3>
      {subtitle && (
        <>
          <br />
          <h6
            className="pl-3 mt-1 mb-0"
            style={{ fontSize: 15, color: '#919191' }}
          >
            {subtitle}
          </h6>
        </>
      )}
      <hr />
    </div>
  )
}

export default StepReport
